import { useTranslation } from 'react-i18next';
import { useP } from '../i18n/useP';
import './YearPicker.css';

/**
 * YearPicker — sélecteur d'année compact (‹ select ›), à poser dans le slot
 * `aside` d'un <Tabs>. Remplace le picker recodé en dur dans chaque hub
 * (.people-hub__year). Branché sur l'année globale (year / onYearChange).
 *
 * Props :
 *   year         : number              — année courante (fallback : année système)
 *   onYearChange : (year) => void      — changement d'année
 *   label        : string              — libellé à gauche (défaut « Année », '' = aucun)
 */
export default function YearPicker({ year, onYearChange, label }) {
  const { t } = useTranslation();
  const p = useP();
  const resolvedLabel = label === undefined ? p('Année') : label;
  const cy = new Date().getFullYear();
  const options = [...new Set([year, cy + 1, cy, cy - 1, cy - 2])]
    .filter(Boolean)
    .sort((a, b) => b - a);
  const set = v => onYearChange && onYearChange(v);

  return (
    <div className="year-picker">
      {resolvedLabel && <span className="year-picker__label">{resolvedLabel}</span>}
      <button
        type="button"
        className="year-picker__arrow"
        onClick={() => set((year ?? cy) - 1)}
        title={t('phrases:p_cb0544033c')}
      >‹</button>
      <select
        className="year-picker__select"
        value={year ?? cy}
        onChange={e => set(Number(e.target.value))}
      >
        {options.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
      <button
        type="button"
        className="year-picker__arrow"
        onClick={() => set((year ?? cy) + 1)}
        title={t('phrases:p_ef7b69f4ee')}
      >›</button>
    </div>
  );
}
